import { InputNumber, type InputNumberProps } from "antd";
import type { KeyboardEvent } from "react";

/** Input númerico. Serve para números inteiros e decimais */
export function InputNumberQtd({
	style = { width: "100%" },
	precision = 2,
	allowNegative = true,
	...rest
}: InputNumberProps & { allowNegative?: boolean }) {
	const formatter = (value: Optional<string | number>): string => {
		if (!value) {
			return "";
		}

		let newValue = value;

		if (typeof newValue === "string") {
			newValue = newValue.replaceAll(",", "").trim();
		}

		const num = Number(newValue);

		const amount = new Intl.NumberFormat("pt-BR").format(num).trim();

		if (Number.isNaN(amount)) {
			return "";
		}

		return amount;
	};

	const parser = (displayValue: string | undefined): string | number => {
		if (typeof displayValue !== "string" || displayValue === "") {
			return "";
		}

		if (displayValue === "-") {
			return displayValue;
		}

		return Number(displayValue.replaceAll("R$", "").replaceAll(".", "").replaceAll(",", ".").trim());
	};

	const handleOnKeyDown = (e: KeyboardEvent<HTMLInputElement>): void => {
		// Se não deixa negativo não deixa digitar -
		if (!allowNegative && e.key === "-") {
			e.preventDefault();
		}

		// Se for apenas números inteiros não permite . ou ,
		if (precision === 0 && (e.key === "." || e.key === ",")) {
			e.preventDefault();
		}
	};

	return (
		<InputNumber
			type="text"
			controls={false}
			decimalSeparator=","
			style={style}
			formatter={formatter}
			onKeyDown={handleOnKeyDown}
			stringMode={false}
			parser={parser}
			{...rest}
		/>
	);
}
